import superplaceholder from 'superplaceholder';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

//FIXME: Needs to fix mouse hover and keyboard navigate mismatch
const applicationProperties = require('../../../applicationProperties.json');
const search = document.getElementById('js--search');
const searchContainer = document.getElementById('js--search-results');
const contextPath = $('meta[name=context-path]').attr('content');
const imageUrl = applicationProperties.productImageUrl;
const IMAGE_FILE_PATH = applicationProperties.imgFilePath;
let item = -1;
let searchItems;
let searchItemHeight;

function makeSearchHtml(response) {
    return response.map(item => {
        return `
            <li tab-index="-1" aria-selected="false">
                <a href="${contextPath}/product/${item.id}" class="dropdown-book-wrapper">
                    <div class="dropdown-book-cover">
                        <img src="${imageUrl}/45X64/${item.avatar}">
                    </div>
                    <div class="dropdown-book-info">
                        <p class="title">${item.label}</p>
                        <p class="author">${item.authorOrBrand}</p>
                    </div>
                    <div class="book-status d-none">
                        <p>${item.inStock==true ? 'In Stock' : ''}</p>
                    </div>
                    <div class="dropdown-book-price ml-auto">
                        <p>
                        <strike class="price-mrp">${Number(item.productMrp) > Math.round(Number(item.productPrice)) ? `৳${item.productMrp}`: ''} </strike>
                        ${item.dealStatus === 'CURRENT' ? `৳${Math.round(Number(item.dealPrice))}` : `৳${Math.round(Number(item.productPrice))}`}
                        </p>
                    </div>
                    <div class="dropdown-cart-btn ${item.productAvailable == 'yes' ? '' : 'd-none'}">
                        <button product-id='${item.id}' class='btn btn-small js--add-to-cart js--cart-from-search-bar'><i class="ion-android-add"></i> Add</button>
                    </div>
                </a>
            </li> `;
    }).join('');
}

function getLinkType(browseDocument) {
    const linkTypes = {
        'AUTHOR': 'book/author',
        'CATEGORY': 'category',
        'PUBLISHER': 'publisher',
        'BRAND': 'brand'
    };

    return linkTypes[browseDocument.browserPageType] || null;
}

function getImageLink(browseDocument) {
    const imageLinks = {
        'AUTHOR': 'people',
        'CATEGORY': 'category',
        'PUBLISHER': 'company',
        'BRAND': 'company'
    };

    return imageLinks[browseDocument.browserPageType] || null;
}

function getLinkTypeName(browseDocument) {
    const imageLinks = {
        'AUTHOR': 'লেখক',
        'CATEGORY': 'Category',
        'PUBLISHER': 'Publisher',
        'BRAND': 'Brand'
    };

    return imageLinks[browseDocument.browserPageType] || null;
}

function getSearchReference(browseDocument) {
    const imageLinks = {
        'AUTHOR': 'asr101',
        'CATEGORY': 'csr101',
        'PUBLISHER': 'psr101',
        'BRAND': 'bsr101'
    };

    return imageLinks[browseDocument.browserPageType] || null;
}

function makeSearchHtmlForBrowseDocument(response) {
    return response.map(item => {
        return `
            <li tab-index="-1" aria-selected="false">
                <a href="${contextPath}/` + getLinkType(item) +`/${item.browseId}?ref=${getSearchReference(item)}" class="dropdown-book-wrapper browse-document-wrapper">
                    <div class="dropdown-book-cover">           
                        
                        <img class="${item.browserPageType == 'AUTHOR' ? 'rounded-circle' : ''}" src="${!item.logo ? `${IMAGE_FILE_PATH}/default-brand.svg` : `https://ds.rokomari.store/rokomari110/${getImageLink(item)}/${item.logo}`}" alt="brand-logo">
                    </div>
                    <div class="dropdown-book-info">
                        <p class="title">${item.browserPageType == 'CATEGORY' || item.browserPageType == 'AUTHOR' ? item.nameBangla : item.name}</p>
                        <p class="author">${getLinkTypeName(item)}</p>
                    </div>
                </a>
            </li> `;
    }).join('');
}

function searchAction (finalSearchTerm, filterOpt) {
    const filterData = filterOpt ? filterOpt : $('#js--search-filter-input').val();
    $.getJSON(contextPath + '/data/elastic-autocomplete/v2/?term=' + finalSearchTerm + "&search_type=" + filterData, response => {
        if (response && response.productDocuments.length > 0) {
            $('#js--overlay').show();
            const searchHtml = makeSearchHtml(response.productDocuments);
            const browseDocumentHtml = makeSearchHtmlForBrowseDocument(response.browsePageDocuments);
            $(searchContainer).html(browseDocumentHtml + `` + searchHtml);
            //$(searchContainer).html(searchHtml);
            searchContainer.classList.add('active');
            searchItemHeight = searchContainer.children[0].clientHeight;
        } else {
            $('#js--overlay').hide();
            searchContainer.classList.remove('active');
        }
        actionTaken(0, ('searchTerm:' + finalSearchTerm), ('Total result found: ' + response.length), 0);
    });
}

if (search) {
    const keyupOnSearch = fromEvent(search, 'keyup').pipe(debounceTime(400));
    keyupOnSearch.subscribe(event => {
        const term = ($(search).val().trim()).substr(0, 39);
        if (term.length === 0) {
            $('#js--overlay').hide();
            searchContainer.classList.remove('active');
            return;
        }

        if (event.keyCode != 40
            && event.keyCode != 38
            && event.keyCode != 13
            && event.keyCode != 27) {
            const finalSearchTerm = term.split(/\s+/).slice(0, 9).join(" ");
            if (finalSearchTerm && !(/^\s*$/.test(finalSearchTerm))) {
                searchAction(finalSearchTerm);
            }
        }
    })
}

$('.js--search-filter-toggle').on('click', function() {
    const searchT = $('#js--search').val().substr(0, 39).split(/\s+/).slice(0,9).join(' ').trim()
    searchAction(searchT, $(this).attr('data-value'));
})

if (searchContainer) {
    window.addEventListener('click', (e) => {

        if (!searchContainer.contains(e.target) && searchContainer.classList.contains('active')) {
            searchContainer.classList.remove('active');
            $('#js--overlay').hide();
        }
    })
}

function deselectSearchItem() {

    [].forEach.call([...searchContainer.children], (item) => {
        item.classList.remove('selected');
    })
}

function navigateDown(item) {

    deselectSearchItem();

    if (item > 3) {
        searchContainer.scrollTop = searchItemHeight * (item - 3);
    }

    if (item == 0) {
        searchContainer.scrollTop = 0;
    }

    searchContainer.children[item].classList.add('selected');
}


function navigateUp(item) {
    deselectSearchItem();

    if (item > 3) {
        searchContainer.scrollTop = searchItemHeight * (item - 3);
    }
    if (item < 3) {
        searchContainer.scrollTop = 0;
    }
    if (item > -1) {
        searchContainer.children[item].classList.add('selected');
    }
}

function selectSearchItem(currentItem) {
    window.location.href = searchContainer.children[item].firstElementChild.getAttribute('href');
}

if (search) {
    search.addEventListener('keydown', (event) => {

        if (event.keyCode == 40) {
            item < searchContainer.children.length - 1 ? item++ : item = 0;
            navigateDown(item)
        }

        if (event.keyCode == 38) {
            if (item == 0) {
                item = searchContainer.children.length - 1;
            } else if (item > -1) {
                item--;
            }
            navigateUp(item);
        }

        if (event.keyCode == 13 && item > -1) {
            event.preventDefault();
            selectSearchItem(searchContainer.children[item]);
        }

        if (event.keyCode == 27) {
            search.blur();
            searchContainer.classList.remove('active');
            $('#js--overlay').hide();
        }
    })

    // animated search placeholder
    const pageType = $('#js--page-type').val() || '';
    let placeholderContents = [];

    switch(pageType) {
        case 'ELECTRONIC_CATEGORY':
            placeholderContents = [
                'Search by Products (Blender, Trimmer, Headphone)',
                'Search by Categories (Appliances, Gadgets, Computer Accessoriess)',
                'Search by Brands (QCY, Havit, Remax, Amazfit)',
            ];
            break;
        case 'STATIONARY_CATEGORY':
            placeholderContents = [
                'Search by Products (Vaseline Mosquito Defence Lotion, Karkuma Organic Healthy Gut, Deli Desk Organizers)',
                'Search by Categories (Stationery, Toiletries, Organic Food)',
                'Search by Brands (Unilever, Casio, ACI)',
            ];
            break;
        case 'KIDS_ZONE':
            placeholderContents = [
                'Search by Products (NeoCare baby Wipes, Fresh Happy Nappy Diaper, Rubik\'s Cube',
                'Search by Categories (Toy, Diaper, Baby Shampoo)',
                'Search by Brands (Kodomo, Farlin, PUR)',
            ];
            break;
        case 'BRAND':
            placeholderContents = [
                'Search by Products (Hot Wheels, Deli, Karkuma)'
            ];
            break;
        default:
            placeholderContents = [
                'Search by electronics (Auto Volt Shield, 3Watt Dc Tube Light)',
                'Search by superstores (Tangram, Casio Calculator)',
                'Search by books (মনের শক্তি, লগ্নজিতা)'
            ];
            break;
    }

    superplaceholder({
        el: search,
        sentences: placeholderContents,
        options: {
            loop: true,
            startOnFocus: false
        }
    });
}